import { render, staticRenderFns } from "./ClosePayment.vue?vue&type=template&id=601b113b&scoped=true&lang=pug"
import script from "./ClosePayment.vue?vue&type=script&lang=js"
export * from "./ClosePayment.vue?vue&type=script&lang=js"
import style0 from "./ClosePayment.vue?vue&type=style&index=0&id=601b113b&prod&lang=scss&scoped=true"
import style1 from "./ClosePayment.vue?vue&type=style&index=1&id=601b113b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601b113b",
  null
  
)

export default component.exports